<template>
  <div class="c-seo-history">
    <div class="c-page-header c-page-header--flush">
      <div>
        <h3 class="c-page-header__title">
          SEO history
        </h3>
        <p class="c-page-header__subtitle">
          Every change made to SEO rules on this website. Click a row to see what changed.
        </p>
      </div>
    </div>

    <history-log-table
      :logs="historyLogs"
      @open="handleOpen"
    />

    <paginate
      v-if="totalPages > 1"
      v-model="currentPage"
      :page-count="totalPages"
      :prev-text="'‹'"
      :next-text="'›'"
      :page-range="5"
      :margin-pages="1"
      :click-handler="handlePaginate"
      :container-class="'c-pagination'"
      :prev-link-class="'md-button prev md-elevation-1'"
      :next-link-class="'md-button next md-elevation-1'"
      :page-link-class="'md-button md-elevation-1'"
      :break-view-link-class="'md-button'"
      :active-class="'active'"
      :disabled-class="'disabled'"
    />
  </div>
</template>

<script>

import HistoryLogTable from "@/shared/history-log/HistoryLogTable.vue";
import {mapGetters, mapActions} from "vuex";
import {historyLogsService} from "@/services/history-logs";
import HistoryLogModal from "../../../help/sub-pages/help-history-logs/modals/HistoryLogModalComponent.vue";

export default {
  components: {
    HistoryLogTable,
  },
  data() {
    return {
      historyLogs: [],
      totalPages: 1,
      currentPage: 1,
      limit: 100,
    };
  },

  computed: {
    ...mapGetters('helpDomains', ['getSelectedDomainId', 'getSelectedWebsiteId']),
  },

  watch: {
    getSelectedDomainId() {
      this.getHistoryLogs();
    }
  },

  created() {
    this.getHistoryLogs();
  },

  methods: {
    ...mapActions("response", ["handleSuccess", "setGlobalError"]),

    async getHistoryLogs() {
      let response = await historyLogsService.getHistoryLogs({
        websiteId: this.$route.params.id,
        type: 'seo',
        page: this.currentPage,
        limit: this.limit,
      });

      this.historyLogs = response.data.items;
      this.totalPages = response.data.pageCount;
    },

    handleOpen(historyLog) {
      this.$modal.show(
        HistoryLogModal,
        { historyLog: historyLog },
        { height: "auto", width: 960, scrollable: true }
      );
    },

    handlePaginate(currentPage) {
      this.currentPage = currentPage
      this.getHistoryLogs()
    }
  },
};
</script>
<style lang="scss" scoped>
.c-seo-history {
  display: flex;
  flex-direction: column;
}
</style>
